<template>
  <div>
    <div class="compair-layout--box">
      <!-- header / filter -->
      <div class="compair-layout--box-header">
        <h3>Filter</h3>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/3 mt-3">
            <DataInput
              v-model="search"
              type="text"
              label="Suche"
              placeholder="Suche"
              name="search"
              clearable
            />
          </div>
          <div class="vx-col w-full lg:w-1/3 mt-3">
            <DataInput
              v-model="filter.ad_campaign_id"
              type="model"
              label="Kampagnen"
              placeholder="Kampagne"
              multiple
              name="campaign"
              gql-query="adCampaigns"
              allow-null
              gql-filter-type="objectFilter"
              object-filter-attribute="search"
            />
          </div>
          <div class="vx-col w-full lg:w-1/3 mt-3">
            <DataInput
              v-model="filter.user_group_id"
              type="model"
              label="Benutzergruppe"
              placeholder="Benutzergruppe"
              multiple
              name="group"
              gql-query="userGroups"
              allow-null
            />
          </div>
          <div class="vx-col w-full lg:w-1/3 mt-3">
            <DataInput
              v-model="filter.vacancy_id"
              type="model"
              placeholder="Stelle"
              name="vacancy"
              label="Stelle"
              model-label="title"
              gql-query="vacancyPage"
              gql-filter-type="objectFilter"
              object-filter-attribute="searchQuery"
              multiple
              allow-null
            />
          </div>

          <div class="vx-col w-full lg:w-1/3 mt-3">
            <DataInput
              v-model="filter.variant_id"
              type="model"
              placeholder="Ausprägung"
              name="Ausprägung"
              label="Ausprägung"
              model-label="name"
              gql-query="qrCodeVariants"
              multiple
              allow-null
            />
          </div>
        </div>
      </div>
      <!-- body / table -->
      <div class="compair-layout--box-body">
        <template v-if="qrCodes && qrCodes.results && qrCodes.results.length">
          <table class="mb-4">
            <thead>
              <tr>
                <th>Name</th>
                <th>Gruppe</th>
                <th>Stelle / Link</th>
                <th>Ausprägung</th>
                <th>Kampagne</th>
                <th>Erstellt am</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="qrCode in qrCodes.results" :key="qrCode.id">
                <td>
                  {{ qrCode.name }}
                </td>
                <td>
                  <template v-if="qrCode.user_group">
                    {{ qrCode.user_group.name }}
                  </template>
                </td>
                <td>
                  <template v-if="qrCode.vacancy">
                    <router-link
                      class="overview-data-state"
                      :to="{
                        name: 'project.edit.sub.job',
                        params: {
                          id: qrCode.vacancy.project.id,
                          page: 'jobs',
                          jobid: qrCode.vacancy.id
                        }
                      }"
                    >
                      {{ qrCode.vacancy.title }}
                    </router-link>
                  </template>
                  <template v-else>
                    {{ qrCode.base_url }}
                  </template>
                </td>
                <td>{{ qrCode.variant.name }}</td>
                <td>
                  <router-link
                    v-if="qrCode.ad_campaign"
                    :to="{
                      name: 'bi.campaigns.edit',
                      params: { id: qrCode.ad_campaign.id }
                    }"
                  >
                    {{ qrCode.ad_campaign.name }}
                  </router-link>
                </td>
                <td>
                  {{ $d(Date.parse(qrCode.createdAt), "short") }}
                </td>
                <td class="qr-download-col">
                  <span
                    class="cursor-pointer"
                    @click="downloadQr(qrCode.id, qrCode.name)"
                  >
                    <i class="far fa-download"></i>
                  </span>
                  <!-- canvas must exist in order to download image -->
                  <qrcode
                    v-if="(currentQrId = qrCode.id)"
                    :id="qrCode.id"
                    :value="`${qrCode.qr_url}`"
                    :options="{ width: 4000 }"
                    style="display: none"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <vs-pagination
            v-model="currentPage"
            class="mt-6 md:mt-0"
            :total="totalPages"
            :max="7"
            icon-pack="fas"
            prev-icon="fa-chevron-left"
            next-icon="fa-chevron-right"
          />
        </template>
        <template v-else>Keine Ergebnisse. </template>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { paginationMixin } from "@/mixins/paginationMixin.js";
import DataInput from "@/components/ui/DataInput";

export default {
  components: {
    DataInput
  },
  mixins: [paginationMixin("qrCodes")],
  apollo: {
    qrCodes: {
      query: gql`
        query QrCodes(
          $filter: QrCodeFilter!
          $search: String
          $page: Int!
          $size: Int!
        ) {
          qrCodes(filter: $filter, search: $search, page: $page, size: $size) {
            total
            results {
              id
              name
              qr_url
              base_url
              createdAt
              variant {
                id
                name
              }
              vacancy {
                id
                title
                project {
                  id
                }
              }
              user_group {
                id
                name
              }
              ad_campaign {
                id
                name
              }
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return {
          search: this.search,
          filter: this.filter,
          // size: 1000000
          page: this.currentPage,
          size: this.paginationPageSize
        };
      }
    }
  },
  data() {
    return {
      currentPage: 1,
      search: null,
      filter: {
        ad_campaign_id: [],
        user_group_id: [],
        vacancy_id: [],
        variant_id: []
      },
      currentQrId: null
    };
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.$apollo.queries.qrCodes.refetch();
      }
    }
  },
  mounted() {},
  methods: {
    async downloadQr(id, name) {
      this.currentQrId = id;
      await this.$nextTick();
      var link = document.createElement("a");
      link.download = name + ".png";
      link.href = document.getElementById(id).toDataURL();
      link.click();
    }
  }
};
</script>

<style scoped>
.qr-download-col {
  text-align: end;
}
td {
  padding: 1rem;
  /* padding-bottom: 0; */
  opacity: 0.8;
}
tr + tr {
  border-top: 1px solid lightgray;
}
th {
  padding: 1rem;
  padding-bottom: 0;
  font-size: 1.125rem;
  font-weight: 400;
}
h4 {
  margin-left: 0.5rem;
}
table {
  border-collapse: collapse;
  width: 100%;
}
</style>
